module.exports = __webpack_public_path__ + "static/img/人社局一类项目.e6e81225.jpg";